module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud06_m.5535862ddf91d90e8c6d607a44fc49db.png";